var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbleTextIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80.287 72.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.131,
    x2: 0.066,
    y2: 0.927,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e87f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68a6f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M2,32.58v1.344A28.2,28.2,0,0,0,26.086,61.873v4.983A8.343,8.343,0,0,0,39.775,73.3l13.3-11.14A29.58,29.58,0,0,0,52.848,3H31.438A29.509,29.509,0,0,0,2,32.58ZM48.923,55.138,34.636,67.1a.318.318,0,0,1-.521-.245v-8.73A4.026,4.026,0,0,0,30.1,54.092,20.12,20.12,0,0,1,10.029,33.924V32.58a21.461,21.461,0,0,1,21.41-21.512h21.41a21.513,21.513,0,0,1,0,43.025H51.8A4.48,4.48,0,0,0,48.923,55.138ZM24.079,27.086A6.021,6.021,0,1,0,30.1,33.107,6.021,6.021,0,0,0,24.079,27.086Zm12.043,6.021a6.021,6.021,0,1,1,6.021,6.021A6.022,6.022,0,0,1,36.122,33.107Zm24.086-6.021a6.021,6.021,0,1,0,6.021,6.021A6.022,6.022,0,0,0,60.208,27.086Z",
    transform: "translate(-2 -3)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleTextIcon);
export default __webpack_public_path__ + "static/media/BubbleTextIcon.3ea3bdad63e24c082ec4e834dda3f152.svg";
export { ForwardRef as ReactComponent };